import config from '@/api/config'

let subUrl = '/outlet'

export default {
  getOutlet: {
    url: function (params, {version = config.version2}) {

      let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&')
      if (queryString) {
        queryString = '?' + queryString
      }

      return config.baseUrl + version + subUrl + queryString
    }
  },
  getOutletAdditional: {
    url: function (params, {version = config.version3}) {

      let queryString = Object.keys(params).map(key => key + '=' + params[key]).join('&')
      if (queryString) {
        queryString = '?' + queryString
      }

      return config.baseUrl + version + subUrl + '/additional' + queryString
    }
  },
  getTimes: {
    url: function () {
      return config.baseUrl + config.version2 + subUrl + '/getTimes'
    }
  }
}
